<template>
  <v-dialog v-model="dialogTOS" scrollable max-width="600" persistent>
    <v-card class="pa-2">
      <v-card-title class="blue--text title center-text">
          We've updated our Terms of Use
      </v-card-title>
      <v-card-text style="height: 300px;">
        <TOU />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn rounded dark color="blue" @click="agree()">
          I agree
        </v-btn>
      </v-card-actions>

      </v-card>

    </v-card>
  </v-dialog>

</template>
<script>
import TOU from '@/views/TOU.vue'
import firebase from 'firebase'
export default {
  name: 'dialogTOU',
  data() {
    return {
      dialogTOS: !this.$store.state.userData.tos,
    }
  },
  components: {
    TOU
  },
  methods: {
    agree() {
      firebase.firestore().collection('users')
      .doc(firebase.auth().currentUser.uid)
      .update({
        tos: true,
        tosTime: new Date()
      })
      .then(() => {
        this.dialogTOS = false
      })
    }
  }

}

</script>
<style>


</style>
